import { render } from "./DialogAlreadyValidatedAnother.vue?vue&type=template&id=1bf6bf8a"
import script from "./DialogAlreadyValidatedAnother.vue?vue&type=script&lang=js"
export * from "./DialogAlreadyValidatedAnother.vue?vue&type=script&lang=js"
script.render = render

export default script